import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminStudioListItem } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveAdminStudio = createAsyncThunk<AdminStudioListItem, string, { extra: Partial<Dependencies> }>(
  "admin/studio/retrieve",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.getStudioById(id);
  },
);

export const resetRetrieveAdminStudio = createAction("admin/studio/resetRetrieve");
